__turbopack_context__.v({
  "instagram": "Markdown-module-scss-module__c6nhYa__instagram",
  "instagramContainer": "Markdown-module-scss-module__c6nhYa__instagramContainer",
  "link": "Markdown-module-scss-module__c6nhYa__link",
  "postHeight": "Markdown-module-scss-module__c6nhYa__postHeight",
  "reelHeight": "Markdown-module-scss-module__c6nhYa__reelHeight",
});
